import { API_ENDPOINTS } from "config/config";

const get = (api, url, params) =>
  api.get(url, { params }).then((r) => r.data.data);

export const getUtmOptions = (api) => get(api, API_ENDPOINTS.UTM_OPTIONS);

export const generateUtmLinks = (api, body) =>
  api.post(API_ENDPOINTS.UTM_GENERATE, body).then((r) => r.data.data);

export const fetchUtmLinks = (api, params) => get(api, API_ENDPOINTS.UTM_LIST, params);

export const exportUtmLinks = (api, params) => get(api, API_ENDPOINTS.UTM_EXPORT, params);

export const updateUtmLinkUrl = (api, id, url) =>
  api.put(`${API_ENDPOINTS.UTM}/${id}/url`, { url }).then((r) => r.data.data);
